export default __webpack_public_path__ + "static/media/source_serif_pro.6f22301c.ttf";